import * as React from 'react'

import { stringifyError } from '@ally/ally-login'
import allytm from '@ally/allytm'
import { deprecated } from '@ally/metronome-icons'
import { Box, Button, Icon, TextBody } from '@ally/metronome-ui'

import { useAppState } from '../../../AppStateProvider'
import { useTransmit } from '../../../TransmitContext'

interface GuestEnrollExistingEmailBannerProps {
  error: Error | string | undefined
}

export const GuestEnrollExistingEmailBanner: React.FC<GuestEnrollExistingEmailBannerProps> = ({
  error,
}) => {
  const { isWebWrapped } = useAppState()

  const { navigateToLogin } = useTransmit()
  const onLoginClick = (): void => {
    if (isWebWrapped) {
      window.location.href = `ally://login`
    } else {
      navigateToLogin()
    }
  }

  React.useEffect(() => {
    const errorMessage =
      "Looks like you've already set up an account with that email. Do you want to log in instead?"

    allytm.event('customError', errorMessage, stringifyError(error))
  }, [])

  return (
    <Box
      display="flex"
      alignItems="center"
      mb="md"
      data-allytm-error="Email already in use"
    >
      <Box flexShrink={0}>
        <Icon
          icon={deprecated.muiErrorOutline}
          fill="error"
          mr="xs"
          size="lg"
        />
      </Box>
      <TextBody size="sm" tag="b" focusOnMount>
        Looks like you&apos;ve already set up an account with that email. Do you
        want to <Button variant="link" text="log in" onClick={onLoginClick} />{' '}
        instead?
      </TextBody>
    </Box>
  )
}
